import { cva } from '@/styled-system/css';

export const avatarFullNameRecipe = cva({
  base: {},
  variants: {
    size: {
      xs: {
        _before: {
          content: 'var(--c11n-initials-single)',
        },
      },
      sm: {
        _before: {
          content: 'var(--c11n-initials-single)',
        },
      },
      md: {
        _before: {
          content: 'var(--c11n-initials-single)',
        },
      },
      lg: {
        _before: {
          content: 'var(--c11n-initials-full)',
        },
      },
      xl: {
        _before: {
          content: 'var(--c11n-initials-full)',
        },
      },
      xxl: {
        _before: {
          content: 'var(--c11n-initials-full)',
        },
      },
    },
  },
});
